import { configurationReducer as configuration } from '../../configuration/configuration-slice.js';
import { disableAnalytics, enableAnalytics, updateAnalyticsConfiguration, updateBasicConfiguration, updateProxyBaseUrl, } from './configuration-actions.js';
/**
 * Loads the configuration reducer and returns the available commerce configuration action creators.
 *
 * @param engine - The commerce engine.
 * @returns An object holding the commerce configuration action creators.
 *
 * @group Actions
 * @category Configuration
 */
export function loadConfigurationActions(engine) {
    engine.addReducers({ configuration });
    return {
        disableAnalytics,
        enableAnalytics,
        updateAnalyticsConfiguration,
        updateBasicConfiguration,
        updateProxyBaseUrl,
    };
}
